
import { Component, Prop, Vue } from "vue-property-decorator";
import { API_TCompany, API_TCompany_Filter } from "@/models/cases_expert_companies";
import { SUCCESS_NOTIFICATION_TYPE, ERROR_NOTIFICATION_TYPE } from "@/constants/notification";
import { COMPLIANT_LABEL, NOT_COMPLIANT_LABEL } from "@/constants/compliance";

type ParamsKeyObject = {
  [key: string]: any;
};

const SMALL_FONT_SIZE = "small";

@Component
export default class ExpertCompaniesTable extends Vue {
  @Prop({ type: Array, default: () => ({}) }) readonly items?: API_TCompany[];
  @Prop({ type: Object, default: () => ({}) }) readonly params?: ParamsKeyObject;
  @Prop({ type: Object, default: () => ({}) }) readonly filters?: API_TCompany_Filter;
  @Prop({ type: Boolean, default: false }) readonly loading?: boolean;

  get tableProps() {
    const { loading, headers, items, filters, labels, params } = this;

    return {
      loading,
      headers,
      items,
      filters,
      labels,
      params,
      fontSize: SMALL_FONT_SIZE,
    };
  }

  options = {
    infiniteScroll: true,
    filtersApi: true,
    sortApi: true,
  };

  labels = {
    allLabel: this.$t("table.allLabel"),
    placeholderLabel: this.$t("table.placeholderLabelCompany"),
  };

  headers = [
    {
      text: this.$t("table.headers.companyID"),
      value: "company_id",
      sortable: true,
      align: "start",
      sortBy: "number",
    },
    {
      text: this.$t("table.headers.companyName"),
      value: "company_name",
    },
    {
      text: this.$t("table.headers.complianceAdminName"),
      value: "compliance_admin_name",
    },
    {
      text: this.$t("table.headers.complianceAdminEmail"),
      value: "compliance_admin_email",
      collapse: "35",
    },
    {
      text: this.$t("table.headers.complianceSubscription"),
      value: "compliance_subscription",
      width: "55",
      filterable: true,
    },
    {
      text: this.$t("table.headers.complianceStatus"),
      value: "compliance_status",
      filterable: true,
      error: NOT_COMPLIANT_LABEL,
      success: COMPLIANT_LABEL,
      width: "45",
    },
  ];

  loadData(payload: any) {
    this.$emit("load-data", payload);
  }

  goToCase(item: API_TCompany) {
    const { company_id } = item;

    const routeData = this.$router.resolve(`companies/${company_id}/summary`);

    window.open(routeData.href, "_blank");
  }

  copyToClipboard(text: string) {
    if (!navigator.clipboard) return;

    let type: string;
    let title: string;

    try {
      navigator.clipboard.writeText(text);

      type = SUCCESS_NOTIFICATION_TYPE;
      title = `"${text}" ${this.$t("copied")}`;
    } catch (err) {
      type = ERROR_NOTIFICATION_TYPE;
      title = err as string;
    }

    this.$root.$emit("show-notification", {
      type,
      title,
    });
  }
}
